
function GeneralOptions() {
    'ngInject';

    const options = {
        twelve_hour_format: false,
        calendar_minute_step: 5,
        calendar_slot_duration: 5,
        update_document_title: false,
        scroll_offset: 0,
        map_marker_icon: null,
        mapActiveMarkerIcon: null,
        map_layout: 'default',
        companyHasExternalBookings: false,
        mapMarkerHasLabel: true,
        maxAdvanceDatetimeDays: null,
        canShowPreviousDates: true,
        calendarDaysByScreenWidth: { lg: 7, md: 5, sm: 3, xs: 1 },
        updateBasketErrorSuppressModal: false,
        disableUnbookableServices: false,
        canMakePastBookings: true,
        bookingExport: {
            layout: 'column'
        },
        datetimeFormat: 'LLL',

        // prevents child companies being loaded and replaces company dropdown on login screen
        // with company search by name/ref
        suppressChildCompanies: false,

        // 'locale', 'mile', 'kilometre', 'kilometer': anything else defaults to 'locale'.
        distanceUnit: 'locale',

        //configure GDPR consent
        displayGDPRConsent: true,
        isGDPRConsentRequired: true,
        displayPolicyStatementHTMLContent: false,
        policyStatementHTMLContent: '<span> Check our terms and conditions here <a>privacy policy.</a> </span>'
    };


    this.setOption = function (option, value) {
        if (options.hasOwnProperty(option)) {
            options[option] = value;
        }
    };

    this.$get = () => options;

}

/**
 * @ngdoc service
 * @module BB
 * @name GeneralOptions
 *
 *  * @return {object} options
 *
 *    - **supportedSizes** – `{object}` – Holds information about responsive breakpoints, their names and size.
 *
 * @description
 * Returns a set of General configuration options
 */

/**
 * @ngdoc service
 * @module BB
 * @name GeneralOptionsProvider
 *
 * @description
 * Provider
 *
 * @example
 <pre module='BB.GeneralOptionsProvider'>
 angular.module('ExampleModule').config ['GeneralOptionsProvider', (GeneralOptionsProvider) ->
 GeneralOptionsProvider.setOption('twelve_hour_format', true)
 ]
 </pre>
 */
angular
    .module('BB')
    .provider('GeneralOptions', GeneralOptions);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/general_options.provider.js